<template>
	<div>
		<a-page-header style="background: #fff;" title="积分商品详情" />
		<div style="background: #fff;padding:20px">
			<a-form-model ref="form" :model="form" :rules="formRules" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
				<a-form-model-item label="商品名称" prop="integralGoodsName">
					<a-input v-model="form.integralGoodsName" placeholder="请输入商品名称" />
				</a-form-model-item>
				<a-form-model-item label="商品缩略图" prop="goodsThumb">
					<a-upload name="img" listType="picture-card" class="avatar-uploader" :showUploadList="false" :action="this.$host+'/admin/index.php/admin/qiniu/uploads'"
					 @change="goodsThumbChange">
						<img v-if="form.integralGoodsThumb" :src="form.integralGoodsThumb" alt="avatar" style="width: 150px;height: 150px;" />
						<div v-else>
							<a-icon :type="loading ? 'loading' : 'plus'" />
							<div class="ant-upload-text">上传</div>
						</div>
					</a-upload>
					<div style="color: #ffa940;">建议上传350px * 350px的方形图片 尺寸过大会影响商品列表加载速度</div>
				</a-form-model-item>
				<a-form-model-item label="商品图片">
					<a-upload name="img" :multiple="true" listType="picture-card" class="avatar-uploader" :action="this.$host+'/admin/index.php/admin/qiniu/uploads'"
					 :file-list="fileList" @preview="handlePreview" @change="photoChange">
						<div>
							<a-icon :type="loading ? 'loading' : 'plus'" />
							<div class="ant-upload-text">上传</div>
						</div>
					</a-upload>
					<div style="color: #ffa940;">建议上传750px * 750px的方形图片 尺寸过大会影响商品列表加载速度</div>
				</a-form-model-item>
				<a-form-model-item label="商品简介" prop="integralGoodsCont">
					<a-input v-model="form.integralGoodsCont" placeholder="请输入商品简介" />
				</a-form-model-item>
				<a-form-model-item label="所需积分" prop="integralGoodsPrice">
					<a-input v-model="form.integralGoodsPrice" style="width: 150px;" placeholder="请输入商品售价" suffix="积分" />
				</a-form-model-item>
				<a-form-model-item label="原价" prop="integralGoodsOldPrice">
					<a-input v-model="form.integralGoodsOldPrice" style="width: 150px;" placeholder="请输入商品原价" suffix="元" />
				</a-form-model-item>
				<a-form-model-item label="库存" prop="integralGoodsInventory">
					<a-input v-model="form.integralGoodsInventory" style="width: 150px;" placeholder="请输入商品库存" />
				</a-form-model-item>
				<a-form-model-item label="送达时间">
					隔日到
				</a-form-model-item>
				<a-form-model-item label="虚拟销量" prop='integralGoodsVirtualSales'>
					<a-input v-model="form.integralGoodsVirtualSales" placeholder="请输入虚拟销量" style="width: 150px;"></a-input>
				</a-form-model-item>
				<a-form-model-item label="是否上架">
					<a-switch checked-children="是" un-checked-children="否" v-model="form.integralGoodsStatus" />
				</a-form-model-item>
				<a-form-model-item label="图文详情">
					<tinymce ref="content" v-model="form.integralGoodsContent" />
				</a-form-model-item>
				<a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
					<a-button type="primary" @click="basicSubmit">
						保存
					</a-button>
				</a-form-model-item>
			</a-form-model>
		</div>

		<!-- 上传图片预览 -->
		<a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
			<img alt="example" style="width: 100%" :src="previewImage" />
		</a-modal>
	</div>
</template>

<script>
	import tinymce from '@/components/tinymce.vue'
	export default {
		components: {
			tinymce
		},
		data() {
			return {
				loading: false,
				fileList: [],
				form: {
					integralGoodsVirtualSales: 0,
					integralGoodsStatus: false
				},
				formRules: {
					integralGoodsName: [{
						required: true,
						message: '请填写商品名称',
						trigger: 'blur'
					}],
					integralGoodsPrice: [{
						required: true,
						message: '请填写所需积分',
						trigger: 'blur'
					}],
				},
				previewVisible: false,
				previewImage: '',
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getDetail()
		},
		methods: {
			goodsThumbChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					this.form.integralGoodsThumb = info.file.response.url;
					this.loading = false;
				}
			},

			handleCancel() {
				this.previewVisible = false;
			},

			async handlePreview(fileList) {
				this.previewImage = (fileList.url ? fileList.url : fileList.response.url) || file.preview;
				this.previewVisible = true;
			},

			photoChange({
				fileList
			}) {
				this.fileList = fileList
			},

			basicSubmit() {
				// console.log(this.fileList)
				this.$refs.form.validate(valid => {
					if (valid) {
						if (!this.form.integralGoodsThumb) {
							this.$message.error('请上传商品缩略图');
							return false
						}
						if (!this.fileList) {
							this.$message.error('请上传商品图片');
							return false
						}
						let integralGoodsPic = []
						for (var i = 0; i < this.fileList.length; i++) {
							integralGoodsPic.push({
								name: this.fileList[i].name,
								size: this.fileList[i].size,
								status: this.fileList[i].status,
								url: this.fileList[i].url ? this.fileList[i].url : this.fileList[i].response.url
							});
						}
						let data = {
							id: this.id,
							integralGoodsName: this.form.integralGoodsName,
							integralGoodsThumb: this.form.integralGoodsThumb,
							integralGoodsPic: JSON.stringify(integralGoodsPic),
							integralGoodsCont: this.form.integralGoodsCont,
							integralGoodsPrice: this.form.integralGoodsPrice,
							integralGoodsOldPrice: this.form.integralGoodsOldPrice,
							integralGoodsInventory: this.form.integralGoodsInventory,
							integralGoodsVirtualSales: this.form.integralGoodsVirtualSales,
							integralGoodsStatus: this.form.integralGoodsStatus,
							integralGoodsContent: this.form.integralGoodsContent,
						}
						this.$http.post('/admin/index.php/admin/Shop/integralSave', data).then(res => {
							if (res.data.code == 1) {
								this.$message.success(res.data.msg)
								this.getDetail()
							} else {
								this.$message.error(res.data.msg)
							}
						})
					}
				});
			},
			
			getDetail() {
				this.$http.post('/admin/index.php/admin/Shop/integralInfo', {
					id: this.id,
				}).then(res => {
					if (res.data.code == 1) {
						this.form = res.data.data
						this.fileList = res.data.data.integralGoodsPic
					}
				})
			},

			getGoodsClassList() {
				this.$http.get('/admin/index.php/admin/Shop/classPullList').then(res => {
					if (res.data.code == 1) {
						this.goodsClassList = res.data.data
					}
				})
			}
		},
	}
</script>

<style scoped="">
	.classTitle {
		padding: 20px;
		text-align: center;
		font-size: 20px;
	}

	/deep/ .ant-upload-list-picture-card-container {
		width: 150px;
		height: 150px;
	}

	/deep/ .ant-upload-select-picture-card {
		width: 150px;
		height: 150px;
	}

	/deep/ .ant-upload-list-picture-card .ant-upload-list-item {
		width: 150px;
		height: 150px;
	}

	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}

	.events {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.events .ant-badge-status {
		overflow: hidden;
		white-space: nowrap;
		width: 100%;
		text-overflow: ellipsis;
		font-size: 12px;
	}

	.notes-month {
		text-align: center;
		font-size: 28px;
	}

	.notes-month section {
		font-size: 28px;
	}

	/deep/ .ant-fullcalendar-header .ant-radio-group {
		display: none
	}

	/* For demo */
	.ant-carousel>>>.slick-slide {
		text-align: center;
		height: 160px;
		line-height: 160px;
		background: #364d79;
		overflow: hidden;
	}

	.ant-carousel>>>.custom-slick-arrow {
		width: 25px;
		height: 25px;
		font-size: 25px;
		color: #fff;
		background-color: rgba(31, 45, 61, 0.11);
		opacity: 0.3;
	}

	.ant-carousel>>>.custom-slick-arrow:before {
		display: none;
	}

	.ant-carousel>>>.custom-slick-arrow:hover {
		opacity: 0.5;
	}

	.ant-carousel>>>.slick-slide h3 {
		color: #fff;
	}
</style>
